module.exports = __webpack_public_path__ + "static/media/twitter.5b1da0ca.svg";